import { createLaunchSequence, singleAction } from './LaunchSequence';
import { tryLocalStorage } from 'src/lib/tryLocalStorage';
import {
  canMigrateFromGuestMode,
  handleGuestModeStateMigration,
  setGuestMigration,
} from '../guest/guest.sequence';
import { user, now } from 'src/StateObserver';

/**
 * Launch sequence for handling guest mode state migration in the application.
 *
 * This sequence performs a migration of guest user state when the following conditions are met:
 * - The app is running on a native platform with version iOS >= 2.12.0.
 * - The user has web player credentials for the current app.
 * - The user is logged in via the LINE platform.
 *
 * The migration logic is implemented in {@link handleGuestModeStateMigration}.
 *
 * @see handleGuestModeStateMigration
 */
export const guestStateMigrationSequence = createLaunchSequence([
  singleAction({
    enabled: () => canMigrateFromGuestMode(),
    action: async () => {
      const selectedSummary = await handleGuestModeStateMigration(
        user(),
        tryLocalStorage(),
        now(),
      );

      // If the origin of the state is guest, they just migrated their guest state to LINE.
      // Save it so the game can display the rewards they got for it, later in the launch sequence.
      setGuestMigration(selectedSummary?.origin === 'guest');

      return false;
    },
  }),
]);
